import type { ReactNode } from 'react'

/** Persistent, non-blocking feedback. Its owner persists dismissal and action state. */
export function OperationNotice({ children, actions, onDismiss, busy = false }: {
  children: ReactNode
  actions: ReadonlyArray<{ label: string; onClick: () => void }>
  onDismiss: () => void
  busy?: boolean
}) {
  return <section className="operation-notice" aria-label="Operation result" aria-busy={busy}>
    <p role="status">{children}</p>
    <div className="operation-notice__actions">
      {actions.map(action => <button key={action.label} type="button" className="btn btn-ghost" disabled={busy} onClick={action.onClick}>{action.label}</button>)}
      <button type="button" className="btn btn-ghost" disabled={busy} onClick={onDismiss}>Dismiss</button>
    </div>
  </section>
}
